import type { Qubic } from "api";
import { cubeUrl } from "constants/products.constants";
import { requestAccessUrl } from "./store.model";
import type { Widget } from "./WidgetPreviews";

type StoreWidgetsProps = {
  items: { widget: Widget; qubic: Qubic }[];
};

/** The Web Integration tab: ready-made widgets, each drawn as a small mock-up. */
export const StoreWidgets = ({ items }: StoreWidgetsProps) => (
  <div className="pc-wgts st-web">
    {items.map(({ widget, qubic }) => (
      <div className="pc-wgt" key={widget.slug}>
        <div className="pc-wgt__ph">{widget.preview}</div>
        <div className="pc-wgt__top">
          <img className="pccube" src={cubeUrl(qubic.cube)} alt="" width={28} height={28} />
          <b>{qubic.name}</b>
        </div>
        <p className="pc-wgt__d">{widget.description}</p>
        <a className="pcbtn pc-wgt__b" href={requestAccessUrl(qubic)} target="_blank" rel="noopener noreferrer">
          Request widget
        </a>
      </div>
    ))}
  </div>
);
